<template>
  <div>
    <div class="input-group color-picker" ref="colorpicker">
        <input
          type="text"
          class="form-control"
          :class="inputClasses"
          :name="name"
          :id="id"
          :placeholder="placeholder"
          v-model="valueCopy"

          :readonly="readonly"
          :disabled="disabled"
          :autocomplete="autocomplete"

          :required="required"

          @focus="handleFocus(true)"
          @blur="handleFocus(false)"
          @input="handleModelInput"
        >
        <label class="material-label" :class="activeClass" :for="id">
            <slot></slot>
        </label>
        <span class="input-group-append color-picker-container">
            <span class="input-group-text current-color" :style="'background-color: ' + valueCopy" @click.prevent="!disabled && togglePicker()"></span>
            <chrome-picker :value="colors" @input="updateFromPicker" v-if="displayPicker"/>
        </span>
    </div>
    <help-span :helpText="helpText" />
  </div>
</template>

<script>
import { Chrome } from 'vue-color';

export default {
    name: 'material-color-picker',
    components: {
        'chrome-picker': Chrome,
        HelpSpan: () => import(/* webpackChunkName: "help-span" */ '@/components/form/HelpSpan.vue'),
    },
    computed: {
      computedErrors () {
        return typeof this.errorMessages === 'string'
          ? [this.errorMessages] : this.errorMessages
      },
      computedClasses () {
        return {
          'material--active': this.focus,
          'material--disabled': this.disabled,
          'material--has-errors': Boolean(
            !this.valid ||
            (this.errorMessages && this.errorMessages.length)),
          'material--raised': Boolean(
            this.focus ||
            this.valueCopy || // has value
            (this.placeholder && !this.valueCopy)) // has placeholder
        }
      },
      activeClass () {
        return {
          'active': Boolean(
            this.focus ||
            this.valueCopy || // has value
            (this.placeholder && !this.valueCopy)) // has placeholder
        }
      }
    },
    data () {
      return {
        valueCopy: null,
        focus: false,
        valid: true,
        colors: {
            hex: '#000000',
        },
        colorValue: '',
        displayPicker: false,
      }
    },
    beforeMount () {
        // Here we are following the Vue2 convention on custom v-model:
        // https://github.com/vuejs/vue/issues/2873#issuecomment-223759341
        // this.copyValue(this.value)
    },
    mounted() {
        // this.setColor(this.color || '#000000');
        this.$nextTick( ()=> {
            document.addEventListener('click', this.handleClickOutside);
        });
    },
    destroyed() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    methods: {
        handleModelInput (event) {
            this.$emit('input', event.target.value, event)
            this.handleValidation()
        },
        handleFocus (focused) {
            this.focus = focused
            if(focused){
                this.showPicker();
            }
        },
        handleValidation () {
            this.valid = this.$el ? this.$el.querySelector('.form-control').validity.valid : this.valid
        },
        copyValue (value) {
            this.valueCopy = value;
            this.updateColors(value);
            this.handleValidation();
        },
        setColor(color) {
            this.updateColors(color);
            this.valueCopy = color;
        },
        updateColors(color) {
            if(color.slice(0, 1) == '#') {
                this.colors = {
                    hex: color
                };
            }
            else if(color.slice(0, 4) == 'rgba') {
                var rgba = color.replace(/^rgba?\(|\s+|\)$/g,'').split(','),
                    hex = '#' + ((1 << 24) + (parseInt(rgba[0]) << 16) + (parseInt(rgba[1]) << 8) + parseInt(rgba[2])).toString(16).slice(1);
                this.colors = {
                    hex: hex,
                    a: rgba[3],
                }
            }
        },
        updateFromPicker(color) {
            this.colors = color;
            if(color.rgba.a == 1) {
                this.valueCopy = color.hex;
            }
            else {
                this.valueCopy = 'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a + ')';
            }
        },
        showPicker() {
            document.addEventListener('click', this.documentClick);
            this.displayPicker = true;
        },
        hidePicker() {
            document.removeEventListener('click', this.documentClick);
            this.displayPicker = false;
        },
        togglePicker() {
            this.displayPicker ? this.hidePicker() : this.showPicker();
        },
        handleClickOutside(evt) {
            if (!this.$el.contains(evt.target)) {
                this.focus = false;
            }
        },
        documentClick(e) {
            var el = this.$refs.colorpicker,
                target = e.target;
            if(el !== target && !el.contains(target)) {
                this.hidePicker()
            }
        }
    },
    watch: {
      value: {
          immediate: true,
          handler(value, oldVal) {
            this.copyValue(value || '#000000')
          },
      },
      valueCopy: {
          immediate: true,
          handler(value, oldVal) {
            this.$emit('input', value);
          },
      },
    },
    props: {
      id: {
        type: String,
        default: null
      },
      name: {
        type: String,
        default: null
      },
      value: {
        default: null,
      },
      // default color
      color: {
        default: null,
      },
      placeholder: {
        type: String,
        default: null
      },
      readonly: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      required: {
        type: Boolean,
        default: false
      },
      errorMessages: {
        type: [Array, String],
        default: null
      },
      inputClasses: {
        type: [Array, Object, String],
        default: null
      },
      error: {
        type: String,
        default: null
      },
      helpText: {
        type: String,
        default: null
      },
      autocomplete: {
        type: String,
        default: 'off',
      },
    }

}
</script>

<style lang="scss" scoped>
.vc-chrome {
    position: absolute;
    top: 35px;
    right: 0;
    z-index: 9;
}
.current-color {
    cursor: pointer;
}
</style>